import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 500px;
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  border-radius: 30px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  gap: 20px;
  backdrop-filter: blur(10px);
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
`;

const PlayBtn = styled.button`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent), var(--accent-neon));
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 4px 15px var(--accent-glow);

  svg { width: 24px; height: 24px; fill: white; margin-left: 4px; }
`;

const TrackInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  h4 { margin: 0 0 5px 0; color: var(--text-primary); font-size: 16px; }
  p { margin: 0; color: var(--text-muted); font-size: 12px; }
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  background: var(--glass-2);
  border-radius: 2px;
  margin-top: 10px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0; top: 0; bottom: 0;
    width: 35%;
    background: var(--accent);
    border-radius: 2px;
  }
`;

const PodcastPlayerWidget = ({ node }) => {
  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width}>
      <PlayBtn>
        <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"></path></svg>
      </PlayBtn>
      <TrackInfo>
        <h4>{node.content?.title || 'Tech Talk: 5G Visionen'}</h4>
        <p>{node.content?.author || 'Episode 42 • O2 Business Podcast'}</p>
        <ProgressBar />
      </TrackInfo>
    </Wrapper>
  );
};

registry.register('podcast_player', {
  label: 'Audio Player',
  icon: '🎧',
  category: 'media',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', width: '100%' } },
  render: PodcastPlayerWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Track', fields: [{name:'content.title', label:'Titel', type:'text'}, {name:'content.author', label:'Autor/Subtext', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.width', label:'Breite', type:'text'}, {name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}] }] }
  ]
});
